import { Checkbox } from "./Checkbox"
import { Country } from "./Country"
import { Email } from "./Email"
import { Message } from "./Message"
import { Municipio } from "./Municipio"
import { Number } from "./Number"
import { Provincia } from "./Provincia"
import { Select } from "./Select"
import { State } from "./State"
import { Text } from "./Text"
import { Textarea } from "./Textarea"

export const fields = {
	checkbox: Checkbox,
	country: Country,
	email: Email,
	message: Message,
	municipio: Municipio,
	number: Number,
	provincia: Provincia,
	select: Select,
	state: State,
	text: Text,
	textarea: Textarea,
}
